import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

import { ProjectContentLoader } from "@/components/ProjectContentLoader";
export const Route = createFileRoute("/p/$projectId/$branch")({
  pendingMs: 0,
  pendingComponent: ProjectContentLoader,
  loader: async ({ params }) => {
    if (params.branch === "main") return { task: null };
    const response = await fetch(
      `/api/tasks/${encodeURIComponent(params.branch)}`,
    );
    if (!response.ok) throw notFound();
    const task = (await response.json()) as {
      id: string;
      project_id: string;
      branch_url: string;
      title: string;
      status: "open" | "applied" | "completed" | "archived";
    };
    if (task.project_id !== params.projectId) throw notFound();
    return { task };
  },
  component: Outlet,
});
